<template>
  <step-template :subStep="subStep">
    <v-card-text>
    <v-row v-if="title" style="width: 100%;">
        <v-col
          class="mx-8 mt-5 mb-0"
        >
          <h3 class="text-center text-break" v-html="title"></h3>
        </v-col>
      </v-row>
      <v-row style="width: 100%;">
          <v-col class="text-center text-break mt-5 mb-0">
            <div class="secRisk">
              <table border="0" cellspacing="0" cellpadding="0" width="100%">
                <tr>
                  <td class="secRisk-td-top">
                    <div class="secRisk-header secRisk-score">{{scoreType}}</div>
                  </td>
                </tr>
                <tr>
                  <td class="secRisk-td-bottom">
                    <div class="secRisk-secRisk">{{avatarData.score}}</div>
                  </td>
                </tr>
              </table>
            </div>
          </v-col>
        </v-row>
        <v-row v-if="messageAbove" style="width: 100%;">
          <v-col>
            <h5 
              class="text-center text-break" 
              v-html="messageAbove"
              >
            </h5>
          </v-col>
        </v-row>
        <v-row v-if="messageBox" style="width: 100%;">
          <v-col>
            <v-sheet
            class="pa-6 mx-8 mt-5 mb-0"
            elevation="3"
            rounded
            :color=messageBoxBgColor
          >
            <h5 
              class="text-center text-break" 
              v-html="messageBox"
              :style="`color:${messageBoxTxtColor}`"
              >
            </h5>
          </v-sheet>
          </v-col>
        </v-row>
        <v-row v-if="messageBelow" style="width: 100%;">
          <v-col>
            <h5 
              class="text-center text-break mx-8 mt-5 mb-0" 
              v-html="messageBelow"
              >
            </h5>
          </v-col>
        </v-row>
        <v-row style="width: 100%;">
          <v-col>
            <h5
              class="text-center text-break mx-8 mt-5 mb-0" 
              >
              Click <span style='color:#ff9800;'><b>CONTINUE</b></span> to proceed.
            </h5>
          </v-col>
        </v-row>
    </v-card-text>
  </step-template>
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
import StepTemplate from "/src/components/steps/StepTemplate.vue";
import { controllers } from "chart.js";

export default {
  name: "StepNotification",
  components: {
    StepTemplate,
  },
  props: {
    steps: {
      type: Array,
      required: true,
    },
    step: {
      type: Object,
      required: true,
      default: () => {
        return {};
      },
    },
    subStep: {
      type: Object,
      required: true,
      default: () => {
        return {};
      },
    },
    scoreType: {
      type: String,
      default: "",
      required: true,
    },
    title: {
      type: String,
      default: "",
      required: false,
    },
    messageAbove: {
      type: String,
      required: false,
      default: "",
    },
    messageBox: {
      type: String,
      required: false,
      default: "",
    },
    messageBoxBgColor: {
      type: String,
      required: false,
      default: "#f0faff",
    },
    messageBoxTxtColor: {
      type: String,
      required: false,
      default: "#304156",
    },
    messageBelow: {
      type: String,
      required: false,
      default: "",
    }
  },
  data() {
    return {      
      avatarData: {
        vcte: null,
      }
    };
  },
  computed: {
    ...mapState({
      avatar: (state) => state.avatar,
      caseData: (state) => state.caseData,
      state: (state) => state,
    }),
    avatarVariables() {
      if (JSON.parse(this.avatar.variables)) {
        return JSON.parse(this.avatar.variables);
      }
      return null;
    }
  },
  created() {
    this.init();
  },
  mounted() {
    this.fadeInElements();
  },
  methods: {
    ...mapMutations(["setContinueButtonEnabled"]),
    ...mapActions(["setCaseDataValue"]),
    init() {
      this.setContinueButtonEnabled(true);
      this.setAvatarData();
      this.setAvatarCaseData();
    },
    setAvatarData() {
      if (!this.avatarVariables || !this.avatarVariables.override) {
        return;
      }
      const override = this.avatarVariables.override;
      for (const i in override) {
        if (override[i].subStep && this.matchesSubStepId(override[i].subStep.id)) {
          if (override[i].subStep.props)
            this.addAvatarData(override[i].subStep.props);
        }
      }
    },
    matchesSubStepId(id) {
      // Support both single id and array of ids, with type coercion for string/number comparison
      const currentId = this.subStep.id;
      if (Array.isArray(id)) {
        return id.some(arrId => String(arrId) === String(currentId));
      }
      return String(id) === String(currentId);
    },
    addAvatarData(overrideProps) {
      for (const key in overrideProps) {
        this.avatarData[key] = overrideProps[key];
      }
    },
    setAvatarCaseData() {
      const data = this.avatarData;
      for (var key in data) {
        this.setCaseDataValue({
          key: "avatar" + this.scoreType + "_" + key,
          value: data[key]
        });
      }
    },
    fadeInElements() {
      const elements = [
        document.querySelector('.secRisk-secRisk')
      ];

      let delay = 0;
      elements.forEach((element, index) => {
        setTimeout(() => {
          element.style.transition = 'opacity 3s';
          element.style.opacity = 1;
        }, delay);
        delay += 750;
      });
    }
  }
};
</script>
<style>
  .secRisk {
    width: 100%;
  }
  .secRisk table {
    margin: 0 auto;
    max-width: 600px;
    margin-bottom: 60px;
  }
  .secRisk-header {
    font-weight: bold;
    font-size: 12px;
    padding-top: 10px;
    line-height: 25px;
  }
  .secRisk-score {
    font-size: 25px;
    margin-top: 10px;
  }
  .secRisk-value {
    font-size: 30px;
    font-weight: bold;
  }
  .secRisk-secRisk {
    padding: 40px;
    font-size: 60px;
    font-weight: bold;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
    opacity: 0;
  }
  .secRisk-td-top,
  .secRisk-td-bottom {
    background: rgb(219, 235, 203);
  }
  .secRisk-td-top {
    border-top-right-radius: 15px;
  }
  .secRisk-td-bottom {
    border-bottom-left-radius: 15px;
  }
</style>
